import React, { useState, useEffect, useRef, useContext } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import * as yup from "yup";
import { MultiSelect } from 'primereact/multiselect';
import { Dialog } from 'primereact/dialog';
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import AuthContext from  "../../context/AuthContext";
import { AddEmployee, UpdateEmployee, DeleteEmployee, GetEmployeeAssetList, GetEmployeeIdList, GetEmployeeDetail, GetEmployeeList } from 'services/employee/employee.service';
import { GetDepartmentList } from 'services/other/department.service';
import { GetDesignationList } from 'services/other/designation.service';
import { GetUnits } from 'services/user/user.service';
import { GetPermissions } from 'services/user/user.service';
import { TablePagination } from 'components/Table/TablePagination';
import { Table } from 'components/Table/Table';
import { TableAdvance } from 'components/Table/TableAdvance';
import { TableDetail } from 'components/Table/TableDetail';
import { NameColumn, TextColumn} from 'components/Table/ColumnTemplates/CustomColumn';
import CreateModal from 'components/Modal/CreateModal';
import duplicateNameChecker from 'utilities/duplicateNameChecker';
import { coreAxios } from "utilities/axios";
const BASE_URL = process.env.REACT_APP_MAIN_URL

const Employee = () => {
    const { permissionList } = useSelector((state) => state.permissionList);
    const { employeeAdd, employeeAddLoading } = useSelector((state) => state.employeeAdd);
    const { employeeUpdate, employeeUpdateLoading } = useSelector((state) => state.employeeUpdate);
    const { employeeList, employeeListLoading } = useSelector((state) => state.employeeList);
    const { employeeAssetList, employeeAssetListLoading } = useSelector((state) => state.employeeAssetList);
    const { employeeIdList, employeeIdListLoading } = useSelector((state) => state.employeeIdList);
    const { employeeDetail, employeeDetailLoading } = useSelector((state) => state.employeeDetail);
    const { departmentList } = useSelector((state) => state.departmentList);
    const { designationList } = useSelector((state) => state.designationList);
    const { unitList } = useSelector((state) => state.units);

    const [autoDesignationFilteredValue, setAutoDesignationFilteredValue] = useState([]);
    const [autoDepartmentFilteredValue, setAutoDepartmentFilteredValue] = useState([]);
    const [autoUnitFilteredValue, setAutoUnitFilteredValue] = useState([]);
    
    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [showDetail, setShowDetail] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const [duplicateNameExist, setDuplicateNameExist] = useState(false);

    const [selectedData, setSelectedData] = useState([])

    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();
    const { user } = useContext(AuthContext);


    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        name: "",
        emp_id: "",
        department: "",
        designation: "",
        unit: "",
        email: "",
        phone: "",
    };

    const updateInitialValue = {
        ...employeeDetail,
        department: departmentList?.find((value) => value.id === employeeDetail?.department) || "",
        designation: designationList?.find((value) => value.id === employeeDetail?.designation) || "",
        unit: unitList?.find((value) => value.id === employeeDetail?.unit) || "",
    };

    const duplicateEmployeeIdCheck = (list, updateData, value)=> {
        var check = true
        if(list?.length === 0){
          return check
        }else{
          for (let i=0; i< list?.length; i ++){
            if(updateData){
              if(updateData?.emp_id === value){
                return true
              }else{
                if(value === list[i].emp_id){       
                  return check = false
                }
              }
            }else{
              if(value === list[i].emp_id){       
                return check = false
              }
            }
          }
          return check;
        }
      };

    const validationSchema = yup.object().shape({
        emp_id: yup.string()
        .required("Employee ID is required")
        .test("Unique", "Employee ID must be unique", (values) => {
          return duplicateEmployeeIdCheck(employeeIdList, employeeDetail, values)
        }),
      });
    

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: validationSchema, // * yup schema validation
        onSubmit: (values) => {
            handelSubmit(values);
        },
        enableReinitialize: true,
    });

    const editEmployee = async (employee) => {
        await dispatch(GetEmployeeDetail(employee?.id));
        setShowForm(true); // * set the form to true
        setUpdateData(employeeDetail);
    };

    // delete 1
    const toast = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteEmployee(id));
                await toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetEmployeeList());
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    // form submit handler
    const handelSubmit = async (values) => {
        const updateValue = {
            ...values,
            department: values?.department?.id,
            designation: values?.designation?.id,
            unit: values?.unit?.id,
        };
        if(updateData){
            await dispatch(UpdateEmployee(updateValue)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddEmployee(updateValue)).then(() => {
            hideModal();
            return
        });
    };

    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
        setShowDetail(false);
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    const assetDetails = (itam) => {
        setUpdateData(itam);
        setShowDetail(true); // * set the form to true
        dispatch(GetEmployeeAssetList(itam?.id))
    };

    useEffect(() => {
        dispatch(GetEmployeeList());
    }, [employeeAdd, employeeUpdate]);

    useEffect(() => {
        dispatch(GetPermissions());
    }, []);

    useEffect(() => {
        if(showForm){
            dispatch(GetUnits());
            dispatch(GetDepartmentList());
            dispatch(GetDesignationList());
            dispatch(GetEmployeeIdList());
        }
    }, [showForm, ]);

    const unitFilterTemplate = (options) => {
        return <MultiSelect value={options.value} options={unitList} itemTemplate={unitsItemTemplate} onChange={(e) => options.filterCallback(e.value)} optionLabel="name" placeholder="Any" className="p-column-filter" />;
    };

    const unitsItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    // columns of the table with header name
    const tableColumns = [
        { field: "emp_id", header: "ID", sortableBody: NameColumn },
        { field: "name", header: "Name", filter: true, minWidth: '12rem', sortableBody: NameColumn },
        { 
            field: "unit_name", 
            header: "Unit", 
            filter: true, 

            filterField: "unit_name", 
            showFilterMatchModes: false, 
            filterElement: unitFilterTemplate,
            minWidth: '12rem', 
            filterMenuStyleWidth: '18rem',
            sortableBody: NameColumn 
        },
        { field: "department_name", header: "Department", filter: true, minWidth: '12rem',sortableBody: NameColumn },
        { field: "designation_name", header: "Designation", filter: true, minWidth: '12rem',sortableBody: NameColumn },
        { field: "email", header: "Email", sortableBody: NameColumn },
        { field: "phone", header: "Phone", sortableBody: NameColumn },
    ];
    const detailTableColumns = [
        // { field: "sl", header: "SL", sortableBody: NameColumn },
        { field: "asset", header: "Name", sortableBody: TextColumn },
        { field: "assign_date_only", header: "Assign date", sortableBody: TextColumn },
        { field: "status", header: "Status", sortableBody: TextColumn },
        { field: "return_date_only", header: "Return date", sortableBody: TextColumn },
        { field: "remark", header: "Remark", sortableBody: TextColumn },
    ];

    const searchDepartment = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && departmentList !== undefined) {
                setAutoDepartmentFilteredValue([...departmentList]);
            } else {
                setAutoDepartmentFilteredValue(
                    departmentList?.filter((department) => {
                        return department.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchDesignation = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && designationList !== undefined) {
                setAutoDesignationFilteredValue([...designationList]);
            } else {
                setAutoDesignationFilteredValue(
                    designationList?.filter((designation) => {
                        return designation.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchUnits = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && unitList !== undefined) {
                setAutoUnitFilteredValue([...unitList]);
            } else {
                setAutoUnitFilteredValue(
                    unitList?.filter((unit) => {
                        return unit.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "name",
            name: "name",
            type: "text",
            labelFor: "Name",
            label: "Enter a Name",
            required: true,
            messagePosition: 'toast',
            className: "col-12 md:col-6",
        },
        {
            id: "emp_id",
            name: "emp_id",
            type: "text",
            labelFor: "Employee ID",
            label: "Enter an Employee ID",
            required: true,
            className: "col-12 md:col-6",
            onBlur: (e) => duplicateNameChecker(e.target.value, data, updateData, setDuplicateNameExist),
        },
        {
            id: "department",
            name: "department",
            type: "select",
            labelFor: "department",
            label: "Select Department",
            required: true,
            className: "col-12 md:col-6",
            autoFilteredValue: autoDepartmentFilteredValue,
            autoCompleteMethod: searchDepartment,
            selectedAutoValue: departmentList,
        },
        {
            id: "designation",
            name: "designation",
            type: "select",
            labelFor: "designation",
            label: "Select Designation",
            required: true,
            className: "col-12 md:col-6",
            autoFilteredValue: autoDesignationFilteredValue,
            autoCompleteMethod: searchDesignation,
            selectedAutoValue: designationList,
        },
        {
            id: "unit",
            name: "unit",
            type: "select",
            labelFor: "unit",
            label: "Select Unit",
            required: true,
            className: "col-12 md:col-6",
            autoFilteredValue: autoUnitFilteredValue,
            autoCompleteMethod: searchUnits,
            selectedAutoValue: unitList,
        },
        {
            id: "email",
            name: "email",
            value: "email",
            type: "text",
            labelFor: "email",
            label: "Email",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-6",
        },
        {
            id: "phone",
            name: "phone",
            value: "phone",
            type: "text",
            labelFor: "phone",
            label: "Phone",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-6",
        },
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                {
                    permissionList[0]?.update_permissions.includes(user?.user_type) ?
                    <>
                        <Button 
                            tooltip="Update" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                            icon="pi pi-pencil" 
                            className="p-button-rounded p-button-success mr-2" 
                            onClick={() => editEmployee(rowData)} 
                        />
                    </> : <></>
                }
                {
                    <Button 
                        tooltip="Details" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                        icon="pi pi-list" 
                        className="p-button-outlined p-button-info mr-2" 
                        onClick={(e) => {
                            assetDetails(rowData)
                        }}
                    />
                }
                {
                    permissionList[0]?.delete_permissions.includes(user?.user_type) ?
                    <>
                        <Toast ref={toast} />
                        <ConfirmPopup />
                        <Button 
                            onClick={(e) => {
                                DeleteModal(e, rowData.id);
                            }} 
                            tooltip="Delete" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                            icon="pi pi-trash" 
                            className="p-button-rounded p-button-warning mt-2"
                        />
                    </> : <></>
                }
            </div>
        );
    }

    // useEffect(() => {
    //     fetchData();
    //   }, [currentPage, employeeAdd, employeeUpdate, updateData]);
    
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await coreAxios.get(`${BASE_URL}/api/employee-list/?page=${currentPage}`);
            setData(response.data.results);
            setTotalRecords(response.data.count);
        } catch (error) {
            console.error('Error fetching data: ', error);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (event) => {
        setCurrentPage(event.page + 1);
      };

    return (
        <>
            <Table
                tableHeaderName="Employees"
                tableColumns={tableColumns}
                data={employeeList}
                loading={employeeListLoading}
                dataKey="id"
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
                //Search
                sortable
                searchField
                //Row select
                isRowSelectable={false}
                rows={200}
                scrollable
                scrollHeight = '700px'
                setSelectedData = {setSelectedData}
                selectedData = {selectedData}
                //Toolbar
                exportBtn={false}
                toolbarPermissions={permissionList[0]}

            />
            <CreateModal 
                dialogVisible={showForm} 
                column={12} 
                onHide={hideModal} 
                inputData={inputData} 
                formik={formik} 
                dialogHeader={`${!updateData ? "Create" : "Update "} Employee`} 
                modalWidth="700px" 
                reset={resetForm} 
                btnLoading={employeeAddLoading || employeeUpdateLoading} 
                update={updateData} 
                disabled={duplicateNameExist}
                col1={8}
                col2={updateData ? 0 : 1}
                col3={2}
            />

            <Dialog 
                visible={showDetail} 
                style={{ width: "1400px" }} 
                header="Employee Asset Details"
                className="p-fluid" 
                onHide={hideModal} 
                position="top"
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                {
                    employeeAssetList && 
                    (
                        <TableDetail
                            tableColumns={detailTableColumns}
                            rowData={updateData}
                            data={employeeAssetList}
                            loading={employeeAssetListLoading}
                            dataKey="id"
                        />
                    )
                }

            </Dialog>
        </>
    );
};

export default Employee;
